import { createContext, useContext } from "react";

import type { AccountInfoContextValue } from "./types";

export const AccountInfoContext = createContext<AccountInfoContextValue | null>(null);

export function useAccountInfoContext(): AccountInfoContextValue {
  const context = useContext(AccountInfoContext);
  if (!context) throw new Error("AccountInfo parts must be rendered inside <AccountInfo>");
  return context;
}
